import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Editor, NgxEditorModule, Toolbar, Validators } from 'ngx-editor';
import { CommonServiceService } from '../../../shared/services/common-service.service';
import { NgxImageCompressService } from 'ngx-image-compress';
@Component({
  selector: 'app-custom-blog',
  standalone: true,
  imports: [NgxEditorModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './custom-blog.component.html',
  styleUrl: './custom-blog.component.scss',
})
export class CustomBlogComponent implements OnInit, OnDestroy {
  editor!: Editor;
  htmlContent: any = '';
  toolbar: Toolbar = [
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['bold', 'italic', 'underline'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['indent', 'outdent'],
    ['ordered_list', 'bullet_list'],
    ['link', 'image'],
    ['superscript', 'subscript'],
    ['undo', 'redo'],
  ];
  editordoc: string = '';
  form!: FormGroup;
  Newsform!:FormGroup;
  selectedImage: any;

  constructor(private fb: FormBuilder,private blogDataService: CommonServiceService, private imageCompress: NgxImageCompressService){

  }
  ngOnInit(): void {
    this.editor = new Editor();

    this.Newsform = this.fb.group({
      title:['',Validators.required],
      body:['',Validators.required],
      editorContent: [ { value: this.editordoc, disabled: false }, Validators.required()],
      image:['',Validators.required]
    })
  }

  // make sure to destory the editor
  ngOnDestroy(): void {
    this.editor.destroy();
  }


  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.selectedImage = e.target.result;
        
      };
      reader.readAsDataURL(file);
    }
  }

  async compressImage() {
    const image = new Image();
    image.src = this.selectedImage;

    image.onload = async () => {
      const maxWidth: any = 50;
      const height = 50;
      const quality = 0.9; 

      const result = await this.imageCompress.compressFile(
        image.src,
        maxWidth,
        height,
        quality
      );
      this.selectedImage = result;
    };
  }

  newsFormData(data:any){
   const newsData={
    title:data.title,
    body:data.body,
    img:this.selectedImage,
    htmlContent:data.editorContent
    }
    
    this.blogDataService.insertNews(newsData).subscribe({
      next:(res)=>{
        this.htmlContent = '';
        this.selectedImage = '';
        this.Newsform.reset();
      }
    })
  }

  blogFormReset(){
    this.htmlContent = '';
    this.selectedImage = '';
    this.Newsform.reset();
  }
}
